import styled from "styled-components"
export const Footer = styled.footer`
  background-color: ${({ theme }) => theme.colors.azul};
  margin-top: 0;
  padding: 2rem 0;
  .iconContainer{
    display: flex;
    align-items: center;
    .iconFooter{
      margin-right: .5rem;
    }
  }
  .header {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 1.5em;
    &__img {
      width: 230px;
    }
    &__contactanos {
      display: flex;
      align-items: center;
      div {
        display: flex;
      }
    }
    &__title {
    }
    &__icon {
      color: ${({ theme }) => theme.colors.gris};
      font-size: 5rem;
      padding: 0 1rem;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /* esto solo se mostrara en responsive */
    &__title_img {
      display: none;
    }
    li {
      margin-bottom: 0.5rem;
    }
    &__nav--contacto {
      margin: 0;
      padding-left: 10px;
    }
    &__contacto p {
      margin: 20px 0 8px;
    }
    &__contacto p:first-of-type {
      margin-top: 0;
    }
    .spaceBar {
      display: none;
    }
    &__title {
      font-family: "neue";
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      margin: 1rem 0;
      color: ${({ theme }) => theme.colors.amarillo};
      &-desarrollado {
        font-size: 20px;
      }
    }
    &__direccion .body__title + p + .body__title {
      padding-top: 1.5rem;
    }
    &__redes {
      display: flex;
      gap: 1rem;
      &-icon {
        font-size: 20px;
        color: ${({ theme }) => theme.colors.gris};
        transition: 0.3s;
        &:hover {
          color: ${({ theme }) => theme.colors.amarillo};
        }
      }
    }
    &__link,
    .Nav__link {
      color: ${({ theme }) => theme.colors.gris};
      font-size: 14px !important;
      font-weight: 400 !important;
      transition: 0.3s;
      &:hover {
        color: ${({ theme }) => theme.colors.amarillo} !important;
      }
    }
    &__text {
      color: ${({ theme }) => theme.colors.gris};
      font-size: 14px;
      font-weight: 400;
      &-arequipa {
        flex-basis: 100%;
      }
    }
    &__factory {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      gap: 1.5rem;
    }
    &__developed {
      display: flex;
      flex-direction: column;
      align-items: center;
      & .acidImg {
        width: 80%;
        max-width: 110px;
        height: auto;
      }
    }
    &__img {
      width: 80%;
      max-width: 70px;
    }
  }
  li {
    list-style: none;
  }
  .footer__copy {
    border-top: 0.7px solid #FFFFFF;
    margin-top: 2rem;
    padding: 35px 0 0;
    text-align: center;
    p {
      color: ${({ theme }) => theme.colors.gris};
      font-size: 14px;
      font-weight: 400;
    }
  }
  @media (max-width: 1200px) {
    .header {
      justify-content: center;
    }
    .iconContainer{justify-content:center}
    .body {
      & > div {
        flex-basis: calc(100% / 3);
        text-align: center;
      }
    }
    .body__redes {
      justify-content: center;
    }
  }
  @media (max-width: 920px) {
    .header {
      &__imgLink {
        text-align: center;
      }
    }
    .body {
      & > div {
        flex-basis: 50%;
        text-align: center;
      }
      &__factory {
        flex-basis: 100% !important;
      }
    }
    .body__redes {
      justify-content: center;
    }
  }
  @media (max-width: 500px) {
    .body {
      & > div {
        flex-basis: 100%;
      }
      &__mapaSite {
        display: none;
      }
    }
    .body__redes {
      justify-content: center;
    }
  }
  @media (max-width: 360px) {
    .body {
      &__factory {
        flex-direction: column;
      }
    }
  }
`
